import * as THREE from "three";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js";

/**
 * ドット絵風エフェクトのシェーダー
 */
const DotShader = {
  uniforms: {
    tDiffuse: { value: null },
    resolution: { value: new THREE.Vector2(1, 1) },
    pixelSize: { value: 2 }, // ピクセルサイズ（大きいほど粗くなる）
    colorLevels: { value: 8.0 }, // 色レベル数（少ないほど色が制限される）
  },

  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,

  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform vec2 resolution;
    uniform float pixelSize;
    uniform float colorLevels;
    varying vec2 vUv;

    void main() {
      // ピクセル化
      vec2 dxy = pixelSize / resolution;
      vec2 coord = dxy * floor(vUv / dxy);

      // テクスチャをサンプリング
      vec4 texColor = texture2D(tDiffuse, coord);

      // 色数を制限（パレット化）
      texColor.rgb = floor(texColor.rgb * colorLevels) / colorLevels;

      gl_FragColor = texColor;
    }
  `,
};

/**
 * ドット絵風エフェクトのパス
 */
export class DotShaderPass extends ShaderPass {
  constructor() {
    super(new THREE.ShaderMaterial(DotShader));
  }

  /**
   * 解像度を設定
   */
  setResolution(width: number, height: number): void {
    this.uniforms.resolution.value.set(width, height);
  }

  /**
   * ピクセルサイズを設定（大きいほど粗くなる）
   */
  setPixelSize(size: number): void {
    this.uniforms.pixelSize.value = size;
  }

  /**
   * 色レベル数を設定（少ないほど色が制限される）
   */
  setColorLevels(levels: number): void {
    this.uniforms.colorLevels.value = levels;
  }
}
